/* eslint-disable no-nested-ternary */
import { HistoryAction } from './HistoryAction'
import { HistoryActionType } from './HistoryActionType'
import { setTransitionProperty } from '~/actions/transition/patchTransition'

export class TransitionChangePropertyAction extends HistoryAction {

  constructor(payload, ...params) {
    super(HistoryActionType.TransitionChangePropertyAction, payload, ...params)
    const { changedProperties } = payload
    this._changedProperties = changedProperties
  }

  get changedProperties() {
    return this._changedProperties
  }

  * undo() {
    const { changedProperties } = this
    yield setTransitionProperty(changedProperties, true)
  }

  * redo() {
    const { changedProperties } = this
    yield setTransitionProperty(changedProperties)
  }

}
